import { useState } from 'react';

export default function ShareButtons({ title }: { title: string }) {
  const [copied, setCopied] = useState(false);
  const [toast, setToast] = useState('');

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(''), 2200);
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      showToast('链接已复制到剪贴板');
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      showToast('复制失败，请手动复制浏览器地址');
    }
  };

  const social = [
    { key: 'wechat', label: '微信', icon: 'ri-wechat-line' },
    { key: 'weibo', label: '微博', icon: 'ri-weibo-line' },
    { key: 'qq', label: 'QQ', icon: 'ri-qq-line' },
  ];

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-foreground-500 mr-1 flex items-center gap-1">
          <i className="ri-share-forward-line" />
          分享：
        </span>
        <button
          type="button"
          onClick={copyLink}
          className="h-9 px-3.5 rounded-md border border-background-300 text-sm text-foreground-800 hover:border-primary-500/60 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
        >
          <i className={copied ? 'ri-check-line text-primary-400' : 'ri-link'} />
          {copied ? '已复制' : '复制链接'}
        </button>
        {social.map((s) => (
          <button
            key={s.key}
            type="button"
            onClick={() => showToast(`已模拟分享「${title}」到${s.label}（演示效果）`)}
            className="h-9 px-3.5 rounded-md border border-background-300 text-sm text-foreground-800 hover:border-accent-500/60 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
          >
            <i className={s.icon} />
            {s.label}
          </button>
        ))}
      </div>
      {toast && (
        <p className="text-xs text-accent-400 animate-soft-fade flex items-center gap-1.5">
          <i className="ri-information-line" />
          {toast}
        </p>
      )}
    </div>
  );
}